import { useEffect, type JSX } from "react";

export function ReactScan(): JSX.Element {
    useEffect(() => {
        if (import.meta.env.NEXT_PUBLIC_REACT_SCAN !== "true") return;
        void import("react-scan").then(({ scan }) => {
            scan({ enabled: true });
        });
    }, []);

    return <></>;
}
